export const DeleteLine = ({ width = 24, height = 24, ...rest }) => {
	return (
		<svg width={width} height={height} {...rest} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M8 6.5C7.72386 6.5 7.5 6.72386 7.5 7V19C7.5 19.2761 7.72386 19.5 8 19.5C8.27614 19.5 8.5 19.2761 8.5 19V7C8.5 6.72386 8.27614 6.5 8 6.5Z"
				fill="#666666"
			/>
			<path
				d="M11.5 7C11.5 6.72386 11.7239 6.5 12 6.5C12.2761 6.5 12.5 6.72386 12.5 7V19C12.5 19.2761 12.2761 19.5 12 19.5C11.7239 19.5 11.5 19.2761 11.5 19V7Z"
				fill="#666666"
			/>
			<path
				d="M16 6.5C15.7239 6.5 15.5 6.72386 15.5 7V19C15.5 19.2761 15.7239 19.5 16 19.5C16.2761 19.5 16.5 19.2761 16.5 19V7C16.5 6.72386 16.2761 6.5 16 6.5Z"
				fill="#666666"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20.5 23.5V4H22.5C22.7761 4 23 3.77614 23 3.5C23 3.22386 22.7761 3 22.5 3H16.5V0.5C16.5 0.223858 16.2761 0 16 0H8C7.72386 0 7.5 0.223858 7.5 0.5V3H1.5C1.22386 3 1 3.22386 1 3.5C1 3.77614 1.22386 4 1.5 4H3.5V23.5C3.5 23.7761 3.72386 24 4 24H20C20.2761 24 20.5 23.7761 20.5 23.5ZM15.5 1V3H8.5V1H15.5ZM19.5 23V4H4.5V23H19.5Z"
				fill="#666666"
			/>
		</svg>
	)
}
